export enum LanguageCodes {
  SV = "sv",
  EN = "en",
}
